import React from 'react';
import { AuthBanner } from './AuthBanner';
import { StandardButton } from '../styles/StandardButtons';
import { supabase } from '../lib/supabase';
import './Setup.css';

/**
 * Where a free client / vendor account lands when no company has given it access yet (it has no relation to any company, so there is no workspace to show).
 * It makes no company-scoped request. When a company adds this person to a project, the next sign-in shows that project instead of this page.
 */
export function ExternalAccountHome({ accountType }: { accountType: 'client_account' | 'vendor_account' }) {
  const label = accountType === 'client_account' ? 'client' : 'vendor';
  return (
    <div className="setup-container">
      <div className="setup-content" style={{ maxWidth: '28rem' }}>
        <AuthBanner />
        <h1 className="h1">Your free account is ready</h1>
        <p className="mt-2 text-sm text-gray-700" data-testid="external-account-home">
          You signed up as a {label}. You do not have access to any project yet. When a company gives you access, it will appear here the next time you sign in.
        </p>
        <div className="mt-4 flex justify-end">
          <StandardButton customVariant="white" onClick={() => { supabase.auth.signOut().finally(() => { window.location.href = '/login'; }); }}>
            Sign out
          </StandardButton>
        </div>
      </div>
    </div>
  );
}
